import Vue from "vue";
import Router from "vue-router";
import store from "../store/index";

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: "/",
            redirect: "/downloadPage"
        },
        /**
         * 校友圈管理
         */
        //用户管理
        {
            path: "/ProjectDetails",
            name: "ProjectDetails",
            component: () =>
                import("@/views/ProjectDetails/index.vue")
        },
        //用户管理
        {
            path: "/HistoryProject",
            name: "HistoryProject",
            component: () =>
                import("@/views/ProjectDetails/HistoryProject.vue")
        },
        //用户管理
        {
            path: "/userManage",
            name: "userManage",
            component: () =>
                import("@/views/school-circle-manage/user-man/index.vue")
        },
        // 敏感词管理
        {
            path: "/sensitiveWordManage",
            name: "sensitiveWordManage",
            component: () =>
                import(
                    "@/views/school-circle-manage/sensitive-word-manage/index.vue"
                )
        },
        // 动态管理
        {
            path: "/dynamicManage",
            name: "dynamicManage",
            component: () =>
                import("@/views/school-circle-manage/dynamic-man/index.vue")
        },
        // 举报管理
        {
            path: "/ReportingManagement",
            name: "ReportingManagement",
            component: () =>
                import(
                    "@/views/school-circle-manage/ReportingManagement/index.vue"
                )
        },
        // 屏蔽管理
        {
            path: "/ShieldingManagement",
            name: "ShieldingManagement",
            component: () =>
                import(
                    "@/views/school-circle-manage/ShieldingManagement/index.vue"
                )
        },
        // 公众号动态查看
        {
            path: "/pubilcDynamic",
            name: "pubilcDynamic",
            component: () =>
                import(
                    "@/views/publicAccountManage/pubilcDynamic.vue"
                )
        },
        // 公众号举报管理
        {
            path: "/publicReport",
            name: "publicReport",
            component: () =>
                import(
                    "@/views/publicAccountManage/publicReport.vue"
                )
        },
        // 公众号屏蔽管理
        {
            path: "/publicShield",
            name: "publicShield",
            component: () =>
                import(
                    "@/views/publicAccountManage/publicShield.vue"
                )
        },
        /**
         * 服务管理
         */
        //上架标记管理
        {
            path: "/ListingMarkManagementIndex",
            name: "ListingMarkManagementIndex",
            component: () =>
                import(
                    "@/views/sevice-manage/ListingMarkManagement/ListingMarkManagementIndex.vue"
                )
        },
        //预置角色服务
        {
            path: "/PresetRoleService",
            name: "PresetRoleService",
            component: () =>
                import(
                    "@/views/sevice-manage/PresetRoleService/PresetRoleServiceIndex.vue"
                )
        },
        //预置个人服务
        {
            path: "/PresetPersonalService",
            name: "PresetRolPresetPersonalServiceeService",
            component: () =>
                import("@/views/sevice-manage/PresetPersonalService/index.vue")
        },
        // 服务分类-类型
        {
            path: "/serviceClassifyType",
            name: "serviceClassifyType",
            component: () =>
                import("@/views/sevice-manage/service-classify-type/index.vue")
        },
        // 服务监控
        //服务概览
        {
            path: "/serviceOverviewIndex",
            name: "serviceOverviewIndex",
            component: () =>
                import(
                    "@/views/sevice-manage/service-monitoring/service-overview/index.vue"
                )
        },
        // 服务评分
        {
            path: "/serviceScore",
            name: "serviceScore",
            component: () =>
                import(
                    "@/views/sevice-manage/service-monitoring/service-score/index.vue"
                )
        },
        // 服务访问统计
        {
            path: "/serviceAccessRecordVisitCount",
            name: "serviceAccessRecordVisitCount",
            component: () =>
                import(
                    "@/views/sevice-manage/service-monitoring/service-access-record/visitCount/index.vue"
                )
        },
        // 服务访问日志
        {
            path: "/serviceAccessRecordVisitLog",
            name: "serviceAccessRecordVisitLog",
            component: () =>
                import(
                    "@/views/sevice-manage/service-monitoring/service-access-record/visitLog/index.vue"
                )
        },
        // 服务收藏统计
        {
            path: "/serviceCollectionStatistics",
            name: "serviceCollectionStatistics",
            component: () =>
                import(
                    "@/views/sevice-manage/service-monitoring/service-collection-statistics/index.vue"
                )
        },
        // 服务列表
        {
            path: "/serviceList",
            name: "serviceList",
            component: () =>
                import("@/views/sevice-manage/service-list/index.vue")
        },
        // 服务分类 - 场景
        {
            path: "/serviceClassifyScene",
            name: "serviceClassifyScene",
            component: () =>
                import("@/views/sevice-manage/service-classify-scene/index.vue")
        },
        /**
         * 机器人管理
         */
        // 问题库
        {
            path: "/robotFAQLibrary",
            name: "robotFAQLibrary",
            component: () => import("@/views/robots-manage/faq-library/index.vue")
        },
        // 提问记录
        {
            path: "/robotFAQRecord",
            name: "robotFAQRecord",
            component: () => import("@/views/robots-manage/faq-record/index.vue")
        },
        // 异常反馈
        {
            path: "/robotFeedbackList",
            name: "robotFeedbackList",
            component: () => import("@/views/robots-manage/feedback-list/index.vue")
        },
        // 功能建议
        {
            path: "/robotFucSuggest",
            name: "robotFucSuggest",
            component: () => import("@/views/robots-manage/func-suggestion/index.vue")
        },
        // 机器人基础信息
        {
            path: "/robotBasicInfo",
            name: "robotBasicInfo",
            component: () => import("@/views/robots-manage/basic-info/index.vue")
        },

        /**
         * 轮播图管理
         */
        {
            path: "/slideshowConfig",
            name: "slideshowConfig",
            component: () =>
                import("@/views/slideshow-manage/slideshowConfig.vue")
        },
        /**
         * App配置启动图
         */
        {
            path: "/APPmanage",
            name: "APPmanage",
            component: () => import("@/views/APP-manage/AppConfig.vue")
        },
        /**
         * 电子证件配置
         */
         {
            path: "/EIdConfiguration",
            name: "APPmanage",
            component: () => import("@/views/E-idConfiguration/AppConfig.vue")
        },
        /**
         * 电子证件配置新生
         */
         {
            path: "/EIdConfigNewStudent",
            name: "APPmanage",
            component: () => import("@/views/EIdConfigNewStudent/AppConfig.vue")
        },
        /**
         * 电子证件配置在校生
         */
         {
            path: "/EIdConfigSTUDENT",
            name: "APPmanage",
            component: () => import("@/views/EIdConfigSTUDENT/AppConfig.vue")
        },
        /**
         * 电子证件配置毕业生
         */
         {
            path: "/EIdConfigGRADUATE_STUDENT",
            name: "APPmanage",
            component: () => import("@/views/EIdConfigGRADUATE_STUDENT/AppConfig.vue")
        },
        /**
         * 电子证件配置教工
         */
         {
            path: "/EIdConfigTEACHER",
            name: "APPmanage",
            component: () => import("@/views/EIdConfigTEACHER/AppConfig.vue")
        },
        /**
         * 电子证件配置其他用户
         */
         {
            path: "/EIdConfigOTHER",
            name: "APPmanage",
            component: () => import("@/views/EIdConfigOTHER/AppConfig.vue")
        },
        /**
         * 咨询配置页面 inforMationConfig
         */
         {
            path: "/inforMationConfig",
            name: "inforMationConfig",
            component: () => import("@/views/inforMationConfig/AppConfig.vue")
        },
        /**
         * App配置启动图Loginprompt E-idConfiguration
         */
        {
            path: "/Loginprompt",
            name: "Loginprompt",
            component: () => import("@/views/APP-manage/components/Login-prompt.vue")
        },
        /**
         * App配置启动图Loginprompt
         */
        {
            path: "/organization",
            name: "organization",
            component: () => import("@/views/APP-manage/components/organization.vue")
        },
        /**
         * App配置启动图Loginprompt
         */
        {
            path: "/AlumniOpen",
            name: "AlumniOpen",
            component: () => import("@/views/APP-manage/components/AlumniOpen.vue")
        },
         /**
         * App配置启动图Loginprompt
         */
        {
            path: "/AlumniDHTML",
            name: "AlumniDHTML",
            component: () => import("@/views/APP-manage/components/AlumniDHTML.vue")
        },
         /**
         * App配置启动图Loginprompt
         */
        {
            path: "/AlumniPact",
            name: "AlumniPact",
            component: () => import("@/views/APP-manage/components/AlumniPact.vue")
        },
         /**
         * App配置启动图Loginprompt
         */
        {
            path: "/OfficialContact",
            name: "OfficialContact",
            component: () => import("@/views/APP-manage/components/OfficialContact.vue")
        },
         /**
         * App配置启动图Loginprompt
         */
        {
            path: "/UnitInvoiceTitle",
            name: "UnitInvoiceTitle",
            component: () => import("@/views/APP-manage/components/UnitInvoiceTitle.vue")
        },
          /**
         * App配置启动图Loginprompt
         */
        {
            path: "/AppUccn",
            name: "AppUccn",
            component: () => import("@/views/APP-manage/components/AppUccn.vue")
        },
        // App配置敏感信息
        {
            path: "/sensitiveInformationConfiguration",
            name: "sensitiveInformationConfiguration",
            component: () => import("@/views/APP-manage/components/sensitiveConfiguration.vue")
          /**
         * App配置 两端配置
         */
        },
        {
            path: "/AppServiceSetting",
            name: "AppServiceSetting",
            component: () => import("@/views/APP-SERVICE-SETTING/index")
        },
        {
            path: "/AppPersonalCenter",
            name: "AppPersonalCenter",
            component: () => import("@/views/personalCenter/index")
        },
        // 异常配置
        {
            path: "/APPAbnormalCondition",
            name: "APPAbnormalCondition",
            component: () => import("@/views/APPAbnormalCondition/index")
        },
        /**
         * 登录设备管理
         */
        {
            path: "/deviceManage",
            name: "deviceManage",
            component: () => import("@/views/device-manage/index.vue")
        },
        /**
         * 紧急联系人管理
         */
        {
            path: "/contactsMannage",
            name: "contactsMannage",
            component: () => import("@/views/contacts-mannage/index.vue")
        },
        /**
         * App版本管理
         */
        {
            path: "/APPVersionsManage",
            name: "APPVersionsManage",
            component: () => import("@/views/APP-versions-manage/index.vue")
        },
        /**
         * 应用卡片管理端
         */
        {
            path: "/cardsConfig",
            name: "cardsConfig",
            component: () => import("@/views/card-manage/cardsConfig.vue")
        },
        /**
         * 个人中心管理端
         */
        {
            path: "/MyZOEConfig",
            name: "MyZOEConfig",
            component: () => import("@/views/MyZOE/MyZOEConfig.vue")
        },
        /**
         * 外观显示配置
         */
        {
            path: "/appearanceConfig",
            name: "appearanceConfig",
            component: () => import("@/views/appearance/appearanceConfig.vue")
        },
        /**
         * 预览预登陆
         */
        {
            path: "/previewAdvanceLanding",
            name: "previewAdvanceLanding",
            component: () => import("@/views/appearance/previewAdvance.vue")
        },
        // app 下载
        {
            path: "/downloadPage",
            name: "downloadPage",
            component: () => import("@/views/downLoadPage/index.vue")
        },
        {
            path: "/downloadMiddlePage",
            name: "downloadMiddlePage",
            component: () => import("@/views/downLoadPage/middle.vue")
        },

        //=======================================================================================================web端配置
        //系统直通车
        {
            path: "/generalConfig",
            name: "generalConfig",
            component: () => import("@/views/webConfig/generalConfig.vue")
        },
        //预登录服务展示配置
        {
            path: "/LoginInAdvanceShowConfig",
            name: "LoginInAdvanceShowConfig",
            component: () => import("@/views/webConfig/LoginInAdvanceShowConfig.vue")
        },
        //预登录底部信息配置
        {
            path: "/LoginInAdvanceBottomInformation",
            name: "LoginInAdvanceBottomInformation",
            component: () => import("@/views/webConfig/LoginInAdvanceBottomInformation.vue")
        },
        //框架层配置
        {
            path: "/frameLayerConfig",
            name: "frameLayerConfig",
            component: () => import("@/views/webConfig/frameLayerConfig.vue")
        },
        //服务中心配置
        {
            path: "/serviceCenterConfig",
            name: "serviceCenterConfig",
            component: () => import("@/views/webConfig/serviceCenterConfig.vue")
        },
        //个人中心配置
        {
            path: "/personalCenterConfig",
            name: "personalCenterConfig",
            component: () => import("@/views/webConfig/personalCenterConfig.vue")
        },
    ]
});

router.beforeEach(async (to, from, next) => {
    store.commit('SET_newSearchParams', '')
    // 确定是否有配置信息
    // if (!store.state.config) {
    //   await store.dispatch('setConfig');
    // }
    next();
});

export default router;
